import DrawerMenu from '@bridebook/web/components/app/drawer-menu';
import HeaderContent from './header-content';

const ProtectedHeader = () => (
  <HeaderContent>
    <DrawerMenu alwaysMounted={false} />
  </HeaderContent>
);

export default ProtectedHeader;
